var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "discount-item"
  }, [_c('span', {
    staticClass: "bold bl-color font-size-16 mr-2"
  }, [_vm._v(_vm._s(_vm.discount.zmena) + "%")]), _c('div', [_vm._v(" " + _vm._s(_vm.discount.label) + " - "), _vm.discount.poznamka ? _c('span', [_vm._v(" " + _vm._s(_vm.discount.poznamka))]) : _vm._e()]), _vm.discount.auto_applied ? _c('div', {
    staticClass: "discount-item__automatic"
  }, [_vm._v(" Automaticky uplatnené ")]) : !_vm.loading ? _c('div', [!_vm.picked ? _c('span', {
    staticClass: "ml-2 text-cta noselect",
    on: {
      "click": function click($event) {
        return _vm.applySadzbaChange(_vm.discount.id, _vm.discount.zmena);
      }
    }
  }, [_vm._v(" Uplatniť ")]) : _c('span', {
    staticClass: "ml-2 text-cta noselect",
    on: {
      "click": function click($event) {
        return _vm.removeSadzbaChange(_vm.discount.id, _vm.discount.zmena);
      }
    }
  }, [_vm._v(" Zrušiť ")])]) : _c('div', {
    staticClass: "ml-3"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }